import axios from 'axios'
import config from '@/config'

const actions = {
  SAVE_FINANCIAL_REPORT({rootGetters}, report) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'financial-report/save', report, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  DOWNLOAD_FINANCIAL_REPORT({rootGetters}, reportId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + `financial-report/download/?reportId=${reportId}`, {
          headers: rootGetters.getRequestConfig.headers,
          responseType: 'blob'
        })
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  actions
}
